import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#e14b87" : "#ff5156",
  },
}));

export { BorderLinearProgress };

// Se llama de la siguiente manera, donde totalSize es un estado para obtener el % de los archivos
// const [totalSize, setTotalSize] = useState<number>((0/MAX_FILES_SIZE)*100); 
// <BorderLinearProgress variant="determinate" value={parseInt(totalSize.toFixed(2))} sx={{height:"25px"}} />
